import React, { useState, useEffect } from 'react';
import { Table, message, Spin, Select } from 'antd';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { poblacionalgenero } from '../../../services/perfiles/conponentesServices';
import './tablaG.css';

ChartJS.register(ArcElement, Tooltip, Legend);

const { Option } = Select;

const GeneroTabla = ({ municipioId }) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [yearFilter, setYearFilter] = useState(null);
    const [years, setYears] = useState([]);
    const [chartData, setChartData] = useState(null);

    useEffect(() => {
        if (municipioId) {
            fetchData();
        }
    }, [municipioId]);

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await poblacionalgenero(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;

                if (Array.isArray(fetchedData)) {
                    setData(fetchedData);
                    const uniqueYears = [...new Set(fetchedData.map(item => item.vigencia))];
                    setYears(uniqueYears);
                    setFilteredData(fetchedData);
                    updateChartData(fetchedData); // Actualiza los datos del gráfico al cargar los datos
                } else {
                    throw new Error('Fetched data is not an array');
                }
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            console.error(error);
            message.error('Error al cargar los datos');
        } finally {
            setLoading(false);
        }
    };

    const handleYearChange = (value) => {
        setYearFilter(value);
        if (value) {
            const newData = data.filter(item => item.vigencia === value);
            setFilteredData(newData);
            updateChartData(newData); // Actualiza los datos del gráfico al cambiar el filtro
        } else {
            setFilteredData(data);
            updateChartData(data); // Actualiza los datos del gráfico al resetear el filtro
        }
    };

    const updateChartData = (data) => {
        const hombres = data.reduce((acc, item) => acc + parseFloat(item.porc_hombres), 0);
        const mujeres = data.reduce((acc, item) => acc + parseFloat(item.porc_mujeres), 0);

        const newChartData = {
            labels: ['Hombres', 'Mujeres'],
            datasets: [
                {
                    data: [hombres, mujeres],
                    backgroundColor: ['#36A2EB', '#FF6384'],
                    hoverBackgroundColor: ['#36A2EB', '#FF6384'],
                },
            ],
        };
        setChartData(newChartData);
    };

    const columns = [
        {
            title: 'Vigencia',
            dataIndex: 'vigencia',
            key: 'vigencia',
            className: 'filaP',
            width: '15%',
            render: text => <span>{text}</span>,
        },
        {
            title: 'Porcentaje Hombres',
            dataIndex: 'porc_hombres',
            key: 'porc_hombres',
            className: 'filaP',
            width: '25%',
            render: text => <span>{text}</span>,
        },
        {
            title: 'Porcentaje Mujeres',
            dataIndex: 'porc_mujeres',
            key: 'porc_mujeres',
            className: 'filaP',
            width: '25%',
            render: text => <span>{text}</span>,
        },
        {
            title: 'Total',
            dataIndex: 'total',
            key: 'total',
            className: 'filaP',
            width: '35%',
            render: text => <span>{text}</span>,
        },
    ];

    return (
        <div className="page-content">
            <h3>1.3 Información poblacional por género</h3>
            {loading ? (
                <Spin size="large" />
            ) : (
                <div>
                    {/* Filtro de años */}
                    <div className="filter-container">
                        <Select
                            value={yearFilter}
                            onChange={handleYearChange}
                            placeholder="Seleccionar año"
                            style={{ width: 200 }}
                        >
                            <Option value={null}>Todos</Option>
                            {years.map((year) => (
                                <Option key={year} value={year}>
                                    {year}
                                </Option>
                            ))}
                        </Select>
                    </div>

                    {/* Tabla de datos */}
                    <div className="table-container">
                        <Table
                            columns={columns}
                            dataSource={filteredData}
                            pagination={false}
                            scroll={{ x: '100%' }}
                        />
                    </div>

                    {/* Gráfico de distribución por género */}
                    <h4>Distribución por género</h4>
                    <div className="chart-container">
                        {chartData && <Pie data={chartData} />}
                    </div>
                </div>
            )}
        </div>
    );
};

export default GeneroTabla;
